import React, { useEffect } from "react";
import { AddButton, TopHeading, Wrapper } from "../../../../common/index.style";
import { Col, Divider, Row, message } from "antd";
import { CodeContainer, MarkingArea, DeactivationNotice } from "./index.style";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { getPublisher, resetPublisher } from "../../../../redux/publisherSlice";
import { useParams } from "react-router-dom";
import { copyToClipboard } from "../../../../utils/helper";
import { CMS } from "../../../../services/constants";
import { FiCopy } from "react-icons/fi";

// Mirrors DeactivationReasonEnum in the backend publisher model.
const DEACTIVATION_REASON_LABELS = {
  plugin_removed: "plugin removed",
  admin: "suspended by admin",
  creator_deleted: "creator closed their account",
};

const ViewPublisher = () => {
  const dispatch = useDispatch();
  const [messageApi, contextHolder] = message.useMessage();
  const { id } = useParams();
  const store = useSelector((store) => store);
  useEffect(() => {
    if (id) {
      dispatch(getPublisher({ publisherId: id }));
    }

    return () => {
      dispatch(resetPublisher());
    };
  }, [id, dispatch]);

  const { publisher, loading } = store?.publisher;

  const renderBeehiivIntegration = () => {
    const perArticleSnippet = publisher?.beehiivAPI?.gtmScript?.perArticleSnippet || ''
    return (
      <>
        <Col md={{ span: 24 }}>
          <h2>Beehiiv GTM configuration</h2>
          <p>
            <p>Paste the GTM ID below into the the beehiiv Website builder</p>
            <p><strong>(beehiiv dashboard > Website Builder > Settings > Pixels > Google Tag Manager Pixel ID).</strong></p>
          </p>
          <CodeContainer>

            <div className='codeHeader'>
              <div></div>
              <div
                onClick={() =>
                  copyToClipboard(publisher?.beehiivAPI?.gtmCodeAllArticleMode ?? '', messageApi)
                }
                className='copyCode'>
                Copy Code
              </div>
            </div>

            <pre className='installationCode'>
              {loading
                ? "loading..."
                : (publisher?.beehiivAPI?.gtmCodeAllArticleMode || '')}
            </pre>
          </CodeContainer>
        </Col>

        <Col md={{ span: 24 }}>
          <h2>Per-article pricing snippet</h2>
          <p>
            <p>To set a price on a specific article, or to enable Acta on individual articles without GTM, add an HTML Snippet within the Post prior to the paywall break <strong>(+ 'HTML Snippet').</strong></p>
            <p>Set the article price by replacing ENTER_PRICE_HERE with the price (e.g., 1.50). Works with or without GTM.</p>
          </p>
          <CodeContainer>
            <div className='codeHeader'>
              <div></div>
              <div
                onClick={() =>
                  copyToClipboard(perArticleSnippet, messageApi)
                }
                className='copyCode'>
                Copy Code
              </div>
            </div>

            <pre className='installationCode'>
              {loading
                ? "loading..."
                : perArticleSnippet}
            </pre>
          </CodeContainer>
        </Col>

        {renderBeehiivAdminIntegration()}
      </>
    )
  }

  const renderBeehiivAdminIntegration = () => {

    const allPriceScript = publisher?.beehiivAPI?.gtmScript?.allArticle || ''
    return (
      <>
        <Divider></Divider>
        <Col md={{ span: 24}}>
        <h1>Google Tag Manager Configuration - Custom HTML</h1>
        <p style={{ color: 'red'}} ><strong>Do not share this one to publisher</strong></p>
        </Col>
        <Col md={{ span: 24 }}>
          <h3>Custom HTML - All Article - GTM Tag </h3>
          <CodeContainer>
            <div className='codeHeader'>
              <div></div>
              <div
                onClick={() =>
                  copyToClipboard(allPriceScript, messageApi)
                }
                className='copyCode'>
                Copy Code
              </div>
            </div>

            <pre className='installationCode'>

              {loading
                ? "loading..."
                : allPriceScript}
            </pre>
          </CodeContainer>
        </Col>
      </>
    )
  }

  const renderGhostIntegration = () => {
    return (
      <>
        <Col md={{ span: 24 }}>
          <CodeContainer>
            <div className='codeHeader'>
              <span>Default Code:</span>
              <div
                onClick={() =>
                  copyToClipboard(publisher?.code?.[0] ?? null, messageApi)
                }
                className='copyCode'>
                Copy Code
              </div>
            </div>

            <pre className='installationCode'>
              {loading
                ? "loading..."
                : publisher?.code?.[0]?.split(" ")?.map((item) => {
                  return item + "\n";
                }) ?? null}
            </pre>
          </CodeContainer>
        </Col>

        <Col md={{ span: 24 }}>
          <CodeContainer>
            <div className='codeHeader'>
              <span>Custom Pricing Code:</span>
              <div
                onClick={() =>
                  copyToClipboard(publisher?.code?.[1] ?? null, messageApi)
                }
                className='copyCode'>
                Copy Code
              </div>
            </div>

            <pre className='installationCode'>
              {loading
                ? "loading..."
                : publisher?.code?.[1]?.split(" ")?.map((item) => {
                  return item + "\n";
                }) ?? null}
            </pre>
          </CodeContainer>
        </Col>
      </>
    )
  }

  const renderWordPressIntegration = () => {
    const customPricingSnippet = `<div id="acta-price" data-price="ENTER_PRICE_HERE"></div>`;
    return (
      <>
        <Col md={{ span: 24 }}>
          <CodeContainer>
            <div className='codeHeader'>
              <span>Custom Article Pricing:</span>
              <div
                onClick={() =>
                  copyToClipboard(customPricingSnippet, messageApi)
                }
                className='copyCode'
                title='Copy'>
                <FiCopy size={18} />
              </div>
            </div>

            <pre className='installationCode'>
              {customPricingSnippet}
            </pre>
          </CodeContainer>
          <p style={{ color: '#666', marginTop: 8 }}>
            To set a custom price on a specific article, add a <strong>Custom HTML</strong> block in the WordPress post editor (before the paywall break) and paste this snippet. Replace <code>ENTER_PRICE_HERE</code> with the price (e.g. <code>2.99</code>).
          </p>
          <p style={{ color: '#666' }}>
            The Acta JS is automatically injected by the WordPress plugin — no need to share the script tag.
          </p>
        </Col>
      </>
    )
  }

  const renderCodeIntegration = () => {
    if (publisher.activeCMS === CMS.Beehiiv) {
      return renderBeehiivIntegration();
    }

    if (publisher.activeCMS === CMS.WordPress) {
      return renderWordPressIntegration();
    }

    return renderGhostIntegration();
  }

  return (
    <Wrapper>
      {contextHolder}
      <TopHeading>View Publisher</TopHeading>
      <Row gutter={16}>
        <Col md={{ span: 16 }}>
          <Row>
            <Col span={24}>
              <MarkingArea>
                <h5>
                  {loading
                    ? "loading..."
                    : `Provide this code to ${publisher?.name}`}
                </h5>
              </MarkingArea>
            </Col>
          </Row>
        </Col>
        <Col md={{ span: 8 }} style={{ textAlign: "right" }}>
          <AddButton
            style={{ marginLeft: "1.7em", marginTop: "2em" }}
            to='/publisher'>
            Back to Home
          </AddButton>
        </Col>

        {!loading && publisher?.active === false && (
          <Col md={{ span: 24 }}>
            <DeactivationNotice>
              <h4>
                Inactive —{" "}
                {DEACTIVATION_REASON_LABELS[publisher?.deactivatedReason] ??
                  "reason not recorded"}
              </h4>
              {publisher?.deactivatedAt && (
                <p>
                  Since{" "}
                  {moment(publisher.deactivatedAt).format("D MMM YYYY, HH:mm")}
                </p>
              )}
              {publisher?.deactivatedNote && (
                <blockquote>“{publisher.deactivatedNote}”</blockquote>
              )}
            </DeactivationNotice>
          </Col>
        )}

        {publisher?.stripe?.account_url !== null && (
          <Col md={{ span: 24 }}>
            <CodeContainer>
              <div className='codeHeader'>
                <span>Stripe Onboarding Link:</span>
              </div>

              <pre className='installationCode'>
                {loading ? "loading..." : publisher?.stripe?.account_url}
              </pre>
            </CodeContainer>
          </Col>
        )}
        {renderCodeIntegration()}

      </Row>
    </Wrapper>
  );
};

export default ViewPublisher;
